function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { formatDateArr, format as formatStr, prevDate } from '@bydesign-ui/utils';

function getQuarterStartMonth(date) {
  return Math.floor(date.getMonth() / 3) * 3;
}

export var dateRangeConverters = {
  day: prevDate,
  week: function week(pivot, offset, weekStartDay) {
    return new Date(pivot.getFullYear(), pivot.getMonth(), pivot.getDate() - pivot.getDay() + weekStartDay - offset * 7);
  },
  month: function month(pivot, offset) {
    return new Date(pivot.getFullYear(), pivot.getMonth() - offset, 1);
  },
  quarter: function quarter(pivot, offset) {
    return new Date(pivot.getFullYear(), getQuarterStartMonth(pivot) - offset * 3, 1);
  },
  year: function year(pivot, offset) {
    return new Date(pivot.getFullYear() - offset, 0, 1);
  }
};
export function dynamicDateRangeToFixedDateRange(args) {
  var converters = args.converters,
      dynamicDate = args.dynamicDate,
      format = args.format,
      dateLocal = args.dateLocal,
      _args$weekStartDay = args.weekStartDay,
      weekStartDay = _args$weekStartDay === void 0 ? 0 : _args$weekStartDay,
      _args$pivot = args.pivot,
      pivot = _args$pivot === void 0 ? new Date() : _args$pivot;

  var interval = dynamicDate.interval,
      _dynamicDate$offsets = _slicedToArray(dynamicDate.offsets, 2),
      start = _dynamicDate$offsets[0],
      end = _dynamicDate$offsets[1];

  var value = [converters[interval](pivot, start, weekStartDay), prevDate(converters[interval](pivot, end - 1, weekStartDay))];
  var formattedValue = formatDateArr(value, format, dateLocal);
  return {
    value: formattedValue,
    type: 'fixed'
  };
}
export function isDynamicDateRange(val) {
  var _a;

  return ((_a = val) === null || _a === void 0 ? void 0 : _a.type) === 'dynamic' && Array.isArray(val.offsets);
}
export function getPresetsMatrix(presets, catagories) {
  var presetsGroup = presets.reduce(function (acc, p) {
    (acc[p.category] = acc[p.category] || []).push(p);
    return acc;
  }, {});
  var presetsMatrix = catagories.map(function (c) {
    return presetsGroup[c.key];
  }).filter(Boolean);
  return presetsMatrix;
}
export function dynamicRangeDateToString(value, dynamicDateLocal) {
  var onlyShowStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!value) {
    return '';
  }

  if (!isDynamicDateRange(value)) {
    return onlyShowStart ? value.value[0] : value.value.join(' ~ ');
  }

  if (value.label) {
    return value.label;
  }

  var start = formatStr(dynamicDateLocal.before, {
    value: value.offsets[0],
    unit: dynamicDateLocal[value.interval]
  });

  if (onlyShowStart) {
    return start;
  }

  var end = formatStr(dynamicDateLocal.before, {
    value: value.offsets[1],
    unit: dynamicDateLocal[value.interval]
  });
  return "".concat(start, " ~ ").concat(end);
}